"use client";

import dynamic from "next/dynamic";

const AppsWeb = dynamic(
  () => import("./AppsWeb").then((m) => ({ default: m.AppsWeb })),
  {
    ssr: false,
    loading: () => <div className="apps-web apps-web-placeholder" aria-hidden />,
  },
);

/** Keep the suite mesh JS off the home critical path. */
export function DeferredAppsWeb() {
  return <AppsWeb />;
}
